/* MXDVS info pages, layout A Dossier (sections/mxdvs-info-page.liquid), one layout for every page (03.10.2026).
   Builds the page from its own content in Shopify admin > Pages:
   - FAQ pages (bold lines with an id containing "question") become numbered questions Q.01, Q.02 ... in the groups
     set in the theme editor;
   - every other page is split at its headings (Heading 2) into numbered items 01, 02 ...
   Every item slides open and closed. Open style 1 "clean fold" or 2 "terminal slip" (theme editor).
   The pages in the "> info:" row switch without a page reload: the new page is fetched, swapped in and the address
   updates; back and forward work. Text decodes as it scrolls in; the index follows the scroll. */
(function () {
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var GL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&*+=/<>';
  var Q = 'b[id*="question"],strong[id*="question"]';
  var INLINE = /^(A|SPAN|B|STRONG|EM|I|U|BR|SMALL|SUP|SUB|CODE)$/;
  var pad2 = function (n) { return (n < 10 ? '0' : '') + n; };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  function decodeEl(el, ms) {
    if (!el) return;
    var nodes = [], w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) if (n.nodeValue.trim()) nodes.push(n);
    var orig = nodes.map(function (x) { return x.nodeValue; });
    var total = orig.reduce(function (a, s) { return a + s.length; }, 0) || 1;
    var t0 = performance.now();
    (function step(t) {
      var p = t - t0, idx = 0;
      nodes.forEach(function (nd, j) {
        var s = orig[j], out = '';
        for (var i = 0; i < s.length; i++, idx++) {
          var ch = s[i];
          out += (p >= ms * (0.3 + 0.7 * idx / total) || ch === ' ' || ch === '\n') ? ch : GL[(Math.random() * GL.length) | 0];
        }
        nd.nodeValue = out;
      });
      if (p < ms) requestAnimationFrame(step); else nodes.forEach(function (nd, j) { nd.nodeValue = orig[j]; });
    })(t0);
  }

  /* ---------- reading the page content ---------- */
  function isEmpty(n) {
    if (n.nodeType === 3) return !n.nodeValue.replace(/ /g, ' ').trim();
    if (n.nodeType !== 1) return true;
    var t = n.tagName;
    if (t === 'BR' || t === 'META' || t === 'SCRIPT' || t === 'STYLE') return true;
    if (t === 'IMG' || t === 'IFRAME' || t === 'VIDEO' || t === 'TABLE') return false;
    return !n.textContent.replace(/ /g, ' ').trim() && !n.querySelector('img,iframe,video');
  }
  function flatten(r) {
    var o = [];
    Array.prototype.forEach.call(r.childNodes, function (n) {
      if (n.nodeType === 1 && n.tagName === 'DIV' && !n.classList.contains('bottom-creds')) o = o.concat(flatten(n)); else o.push(n);
    });
    return o;
  }
  /* Loose words, links and line breaks next to each other become one paragraph */
  function joinInline(list) {
    var out = [], run = null;
    list.forEach(function (n) {
      var inl = n.nodeType === 3 || (n.nodeType === 1 && INLINE.test(n.tagName));
      if (inl) {
        if (!run) { if (n.nodeType === 1 && n.tagName === 'BR') return; run = document.createElement('p'); out.push(run); }
        run.appendChild(n.cloneNode(true));
      } else { run = null; out.push(n); }
    });
    out.forEach(function (p) {
      if (p.nodeType !== 1 || p.tagName !== 'P') return;
      while (p.firstChild && (p.firstChild.nodeName === 'BR' || (p.firstChild.nodeType === 3 && !p.firstChild.nodeValue.trim()))) p.removeChild(p.firstChild);
      while (p.lastChild && (p.lastChild.nodeName === 'BR' || (p.lastChild.nodeType === 3 && !p.lastChild.nodeValue.trim()))) p.removeChild(p.lastChild);
    });
    return out;
  }
  /* Old inline styles from the editor (padding, centring, capitals) do not belong in the dossier */
  function clean(n) {
    if (n.nodeType === 1) { n.removeAttribute('style'); n.querySelectorAll('[style]').forEach(function (x) { x.removeAttribute('style'); }); }
    return n;
  }
  function read(src) {
    var box = src.cloneNode(true);
    var faq = !!box.querySelector(Q);
    box.querySelectorAll('.FAQ-question-links, meta, script, #gtx-trans').forEach(function (x) { x.remove(); });
    var nodes = joinInline(flatten(box)).filter(function (n) { return !isEmpty(n); })
      .filter(function (n) { return !(n.nodeType === 1 && n.tagName === 'H1'); }).map(clean);
    var intro = [], items = [], end = [], cur = null;
    nodes.forEach(function (n) {
      if (n.nodeType === 1 && n.classList.contains('bottom-creds')) { end.push(n); return; }
      if (faq) {
        var qb = n.nodeType === 1 ? (n.matches(Q) ? n : n.querySelector(Q)) : null;
        if (qb) {
          var rest = n === qb ? null : n.cloneNode(true);
          if (rest) { var b = rest.querySelector(Q); if (b) b.remove(); }
          cur = { t: qb.textContent.trim(), b: [] }; items.push(cur);
          if (rest && !isEmpty(rest)) cur.b.push(rest);
          return;
        }
        if (n.nodeType === 1 && n.tagName === 'H2' && !cur) return; /* "Frequently asked questions" */
      } else if (n.nodeType === 1 && n.tagName === 'H2') {
        cur = { t: n.textContent.trim(), b: [] }; items.push(cur); return;
      }
      if (n.nodeType === 3) { var p = document.createElement('p'); p.textContent = n.nodeValue.trim(); n = p; }
      if (cur) cur.b.push(n); else intro.push(n);
    });
    return { faq: faq, intro: intro, items: items, end: end };
  }
  function groupsOf(root, doc) {
    if (!doc.faq) return [{ t: '', list: doc.items }];
    var g = (root.getAttribute('data-groups') || '').split(/\n/).map(function (l) {
      var p = l.split('|'); return p.length > 1 ? { t: p[0].trim(), from: parseInt(p[1], 10) || 1 } : null;
    }).filter(Boolean).sort(function (a, b) { return a.from - b.from; });
    if (!g.length) return [{ t: '', list: doc.items }];
    return g.map(function (x, i) {
      var to = g[i + 1] ? g[i + 1].from : Infinity;
      return { t: x.t, list: doc.items.filter(function (q, k) { return k + 1 >= x.from && k + 1 < to; }) };
    }).filter(function (x) { return x.list.length; });
  }

  /* ---------- [free-shipping]: the amounts per country from the nightly shipping sync ---------- */
  function fillShipping(root, src) {
    var spots = [];
    src.querySelectorAll('p,li,span,div').forEach(function (el) { if (!el.children.length && /\[free-shipping\]/i.test(el.textContent)) spots.push(el); });
    if (!spots.length) return;
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-mxi-ship]').textContent); } catch (e) {}
    var T = data.tiers;
    if (!T || !T.zones || !T.zones.length) { spots.forEach(function (el) { el.remove(); }); return; }
    var lab = String(data.labels || '').split(/\n/);
    var names = null;
    try { names = new Intl.DisplayNames(['en'], { type: 'region' }); } catch (e) {}
    var nm = function (c) { try { return names ? names.of(c) : c; } catch (e) { return c; } };
    var money = function (v) { return '€' + (Math.round(v * 100) / 100).toFixed(v % 1 ? 2 : 0).replace('.', ','); };
    /* 18.10.2026: visitors in another currency also see each amount in their own currency, between brackets
       (Shopify's own rate for the visitor's currency; euro visitors see no brackets) */
    var cur = (window.Shopify && Shopify.currency) || {}, code = String(cur.active || 'EUR').toUpperCase(), rate = parseFloat(cur.rate) || 0;
    var own = function (v, cents) {
      if (code === 'EUR' || !rate) return '';
      var x = v * rate, d = cents ? 2 : 0;
      try { return ' (' + new Intl.NumberFormat('nl-BE', { minimumFractionDigits: d, maximumFractionDigits: d }).format(cents ? x : Math.round(x)) + ' ' + code + ')'; } catch (e) { return ' (' + (cents ? x.toFixed(2) : Math.round(x)) + ' ' + code + ')'; }
    };
    var both = function (v) { return money(v) + own(v, v % 1 !== 0); };
    var by = {};
    T.zones.forEach(function (z) { if (z.free == null) return; (by[z.free] = by[z.free] || []).push.apply(by[z.free], z.c); });
    var amounts = Object.keys(by).map(Number).sort(function (a, b) { return a - b; });
    var rows = amounts.map(function (a, i) {
      var cs = by[a], label;
      if (cs.length <= 6) label = cs.map(nm).join(', ');
      else label = i === amounts.length - 1 ? (lab[2] || 'Rest of the world') : (lab[1] || 'Rest of Europe');
      return '<li>' + esc(label) + ': ' + both(a) + '</li>';
    });
    var html = '';
    var me = data.country, mine = null;
    T.zones.forEach(function (z) { if (z.c.indexOf(me) > -1) mine = z; });
    if (mine && mine.free != null) html += '<p><strong>' + esc((lab[0] || 'Your country, [country]: free from [amount], otherwise [fee]').replace('[country]', nm(me)).replace('[amount]', both(mine.free)).replace('[fee]', both(mine.fee))) + '</strong></p>';
    html += '<ul>' + rows.join('') + '</ul>';
    if (T.noship && T.noship.length) html += '<p>' + esc(lab[3] || 'We do not ship to') + ' ' + esc(T.noship.map(nm).join(', ')) + '.</p>';
    spots.forEach(function (el) {
      var box = document.createElement('div');
      box.className = 'mxi-ship';
      box.innerHTML = html;
      var host = el.closest('p,li') || el;
      host.parentNode.replaceChild(box, host);
    });
  }

  /* ---------- [country] and [days]: the visitor's country and its shipping days (18.10.2026) ---------- */
  function fillCountry(root, src) {
    if (!/\[(country|days)\]/i.test(src.textContent)) return;
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-mxi-ship]').textContent); } catch (e) {}
    var me = String(data.country || '').toUpperCase(), name = data.countryName || me, days = '', rest = '';
    String(data.days || '').split(/\n/).forEach(function (l) {
      var p = l.split('|'); if (p.length < 3) return;
      if (p[1].trim() === '*') { if (!rest) rest = p[2].trim(); return; }
      var cs = p[1].split(',').map(function (c) { return c.trim().toUpperCase(); });
      if (!days && cs.indexOf(me) > -1) days = p[2].trim();
    });
    days = days || rest || 'a few';
    var w = document.createTreeWalker(src, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      if (!/\[(country|days)\]/i.test(n.nodeValue)) continue;
      n.nodeValue = n.nodeValue.replace(/\[country\]/gi, name).replace(/\[days\]/gi, days);
    }
  }

  /* ---------- drawing ---------- */
  function build(root) {
    if (root.classList.contains('is-built')) return;
    var src = root.querySelector('[data-mxi-src]'), out = root.querySelector('[data-mxi-out]'), meta = root.querySelector('[data-mxi-meta]');
    if (!src || !out) return;
    fillCountry(root, src);
    fillShipping(root, src);
    var doc = read(src), groups = groupsOf(root, doc);
    var slip = root.getAttribute('data-style') === '2';
    var firstOpen = root.getAttribute('data-first-open') === 'true';
    var k = 0, index = '', list = '';
    groups.forEach(function (g, gi) {
      if (doc.faq && g.t) {
        index += '<a href="#mxi-g' + gi + '" data-go="mxi-g' + gi + '"><span class="mxi-n">' + pad2(gi + 1) + '</span>' + esc(g.t) + '</a>';
        list += '<h2 class="a-cat" id="mxi-g' + gi + '" data-spy data-reveal>' + esc(g.t) + '</h2>';
      }
      g.list.forEach(function (it) {
        k++;
        var open = firstOpen && k === 1, code = (doc.faq ? 'Q.' : '') + pad2(k);
        if (!doc.faq || !g.t) index += '<a href="#q' + k + '" data-go="q' + k + '"><span class="mxi-n">' + pad2(k) + '</span>' + esc(it.t) + '</a>';
        var holder = document.createElement('div');
        it.b.forEach(function (x) { holder.appendChild(x.cloneNode(true)); });
        var body = '<div class="a-body">' + holder.innerHTML + '</div>';
        var inner = slip ? '<div class="a-slip"><span class="log">&gt; ' + (doc.faq ? 'answer ' : 'clause ') + pad2(k) + '</span>' + body + '</div>' : body;
        list += '<div class="a-q' + (open ? ' open' : '') + '" id="q' + k + '"' + (doc.faq && g.t ? '' : ' data-spy') + '><button type="button" class="a-qh" aria-expanded="' + open + '"><span class="mxi-n">' + code + '</span><span>' + esc(it.t) + '</span><span class="pm" aria-hidden="true">' + (open ? '-' : '+') + '</span></button><div class="fold a-qa"><div>' + inner + '</div></div></div>';
      });
    });
    var intro = doc.intro.map(function (x) { return x.outerHTML || ''; }).join('');
    out.innerHTML = (intro ? '<div class="a-intro' + (doc.faq ? ' a-intro--note' : '') + '" data-reveal>' + intro + '</div>' : '') +
      (k ? '<div class="a-grid"><nav class="a-index" aria-label="Index">' + index + '</nav><div class="a-doc">' + list +
        (doc.end.length ? '<div class="a-end">' + doc.end.map(function (x) { return x.innerHTML; }).join('') + '</div>' : '') + '</div></div>' : '');
    if (meta) meta.textContent = (root.getAttribute(doc.faq ? 'data-label-answers' : 'data-label-items') || '[n]').replace('[n]', k);
    root.classList.add('is-built');
    wire(root);
  }

  var cleanup = [];
  function wire(root) {
    cleanup.forEach(function (f) { f(); }); cleanup = [];
    var ms = parseInt(root.getAttribute('data-decode'), 10) || 0;
    var sticky = function () { return parseFloat(getComputedStyle(root).getPropertyValue('--sticky')) || 125; };
    var scrollToEl = function (el, smooth) { window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - sticky(), behavior: smooth && !RM ? 'smooth' : 'auto' }); };
    root.querySelectorAll('.a-qh').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = b.parentElement, o = q.classList.toggle('open');
        b.setAttribute('aria-expanded', o); b.querySelector('.pm').textContent = o ? '-' : '+';
        if (o && ms && !RM) decodeEl(q.querySelector('.a-body'), ms * 0.6);
      });
    });
    root.querySelectorAll('[data-go]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var el = document.getElementById(a.getAttribute('data-go')); if (!el) return;
        e.preventDefault();
        if (el.classList.contains('a-q') && !el.classList.contains('open')) el.querySelector('.a-qh').click();
        scrollToEl(el, true);
      });
    });
    var secs = Array.prototype.slice.call(root.querySelectorAll('[data-spy]'));
    var links = Array.prototype.slice.call(root.querySelectorAll('.a-index a'));
    if (secs.length && links.length) {
      var spy = function () { var top = sticky() + 17.5, cur = 0; secs.forEach(function (s, i) { if (s.getBoundingClientRect().top <= top) cur = i; }); links.forEach(function (l, i) { l.classList.toggle('on', i === cur); }); };
      window.addEventListener('scroll', spy, { passive: true }); spy();
      cleanup.push(function () { window.removeEventListener('scroll', spy); });
    }
    /* Open an item from the address: #q8, or the old #Q8%20question links */
    var h = decodeURIComponent(location.hash || '').match(/^#q(\d+)/i);
    if (h) {
      var q = document.getElementById('q' + h[1]);
      if (q) { if (!q.classList.contains('open')) q.querySelector('.a-qh').click(); setTimeout(function () { scrollToEl(q, false); }, 50); }
    }
    /* While testing with ?view=info the top row keeps the test view */
    if (/[?&]view=info\b/.test(location.search)) root.querySelectorAll('[data-mxi-sib]').forEach(function (a) {
      if (a.href.indexOf('view=info') < 0) a.href = a.getAttribute('href') + (a.getAttribute('href').indexOf('?') > -1 ? '&' : '?') + 'view=info';
    });
    root.querySelectorAll('[data-mxi-sib]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0 || a.classList.contains('on')) { if (a.classList.contains('on')) e.preventDefault(); return; }
        e.preventDefault();
        swap(root, a.href, true);
      });
    });
    /* Decode as it scrolls in */
    if (!ms || RM || !('IntersectionObserver' in window)) return;
    var els = root.querySelectorAll('[data-reveal], .a-qh');
    els.forEach(function (e) { e.classList.add('pre'); });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (!en.isIntersecting) return; var el = en.target; io.unobserve(el); el.classList.remove('pre'); decodeEl(el, ms); });
    }, { threshold: 0.15 });
    els.forEach(function (e) { io.observe(e); });
    cleanup.push(function () { io.disconnect(); });
  }

  /* ---------- switching pages without a reload ---------- */
  var busy = false;
  function swap(root, url, push) {
    if (busy) return;
    busy = true;
    var ms = RM ? 0 : (parseInt(root.getAttribute('data-swap'), 10) || 0);
    var body = root.querySelector('[data-mxi-body]');
    if (body) body.classList.add('is-out');
    var started = Date.now();
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-mxi]');
        if (!fresh) throw new Error('no info page');
        setTimeout(function () {
          root.innerHTML = fresh.innerHTML;
          root.className = fresh.className;
          ['data-groups', 'data-label-answers', 'data-label-items', 'data-style', 'data-first-open', 'data-decode', 'data-swap'].forEach(function (a) {
            if (fresh.hasAttribute(a)) root.setAttribute(a, fresh.getAttribute(a));
          });
          root.classList.remove('is-built');
          if (doc.title) document.title = doc.title;
          if (push) history.pushState({ mxi: 1 }, '', url);
          window.scrollTo({ top: 0, behavior: 'auto' });
          build(root);
          var t = root.querySelector('[data-mxi-title]');
          var ms2 = parseInt(root.getAttribute('data-decode'), 10) || 0;
          if (t && ms2 && !RM) decodeEl(t, ms2 * 0.8);
          var b2 = root.querySelector('[data-mxi-body]');
          if (b2 && ms) { b2.classList.add('is-out'); requestAnimationFrame(function () { requestAnimationFrame(function () { b2.classList.remove('is-out'); }); }); }
          busy = false;
        }, Math.max(0, ms - (Date.now() - started)));
      })
      .catch(function () { busy = false; window.location.href = url; });
  }
  window.addEventListener('popstate', function () {
    var root = document.querySelector('[data-mxi]');
    if (root) swap(root, location.href, false);
  });

  function boot() { document.querySelectorAll('[data-mxi]').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { document.querySelectorAll('[data-mxi]').forEach(function (r) { r.classList.remove('is-built'); build(r); }); });
})();
